const products = [
  {
    id: 1,
    name: "iPhone 15 Pro",
    price: "350,000 ֏",
    category: "Հեռախոսներ",
    phone: "091123456",
    description: "iPhone 15 Pro, գերազանց վիճակում։",
    image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=800",
  },
  {
    id: 2,
    name: "Samsung Galaxy S24",
    price: "280,000 ֏",
    category: "Հեռախոսներ",
    phone: "094234567",
    description: "Samsung Galaxy S24, լավ վիճակում։",
    image: "https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=800",
  },
  {
    id: 3,
    name: "Nike Air Max",
    price: "55,000 ֏",
    category: "Հագուստ",
    phone: "099345678",
    description: "Nike Air Max, օրիգինալ և շատ լավ վիճակում։",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800",
  },
  {
    id: 4,
    name: "Adidas Hoodie",
    price: "35,000 ֏",
    category: "Հագուստ",
    phone: "077456789",
    description: "Adidas Hoodie, նոր վիճակում։",
    image: "https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?w=800",
  },
  {
    id: 5,
    name: "MacBook Pro 14",
    price: "650,000 ֏",
    category: "Համակարգիչներ",
    phone: "093567890",
    description: "MacBook Pro 14, հզոր և արագ համակարգիչ։",
    image: "https://images.unsplash.com/photo-1517336714739-489689fd1ca8?w=800",
  },
  {
    id: 6,
    name: "ASUS Gaming Laptop",
    price: "450,000 ֏",
    category: "Համակարգիչներ",
    phone: "055678901",
    description: "Gaming laptop, բարձր արտադրողականությամբ։",
    image: "https://images.unsplash.com/photo-1603302576837-37561b2e2302?w=800",
  },
  {
    id: 7,
    name: "Modern Sofa",
    price: "180,000 ֏",
    category: "Կահույք",
    phone: "091789012",
    description: "Ժամանակակից և հարմարավետ բազմոց։",
    image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800",
  },
  {
    id: 8,
    name: "BMW 3 Series",
    price: "12,500,000 ֏",
    category: "Մեքենաներ",
    phone: "094890123",
    description: "BMW 3 Series, լավ տեխնիկական վիճակում։",
    image: "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800",
  },
];

export default products;